import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Worksheet, WorksheetItem, WorksheetQuery, WorksheetService, WorksheetType } from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgb-worksheet-list',
  templateUrl: './worksheet-list.component.html',
  styleUrls: ['./worksheet-list.component.scss'],
})
export class WorksheetListComponent implements OnInit {
  @Input() colOverride: string = '';
  @Input() isGalleryPage: boolean;
  @Input() isWorksheetPage: boolean;
  @Input() isOffers: boolean;

  worksheetType = WorksheetType;
  isList: boolean = true;
  worksheets$: Observable<Worksheet[]>;
  worksheet$: Observable<Worksheet>;
  firstVideoItem: WorksheetItem | undefined;
  listVideos: WorksheetItem[] | undefined;

  constructor(private worksheetService: WorksheetService, private worksheetQuery: WorksheetQuery, private router: Router) {}
  customOptions: OwlOptions = {
    margin: 24,
    pullDrag: true,
    autoplay: false,
    navSpeed: 700,
    nav: false,
    dots: true,
    responsive: { 0: { items: 2 }, 900: { items: 3 } },
  };
  offerCustomOptions: OwlOptions = { ...this.customOptions, responsive: { 0: { items: 1 }, 900: { items: 3 } } };
  ngOnInit() {
    let currentUrl = this.router.url.replace('/', '');
    if (this.isOffers) {
      currentUrl = 'homepage';
    }
    this.isWorksheetPage = this.router.url.includes('worksheet');
    this.worksheets$ = this.worksheetQuery.getWorksheetByRoute(currentUrl);
    if (!this.worksheetQuery.hasRoute(currentUrl)) {
      firstValueFrom(this.worksheetService.fetchWorksheetByRoute(currentUrl));
    }
    this.worksheets$.subscribe((worksheetItem) => {
      if (worksheetItem.length > 0 && worksheetItem[0].Items) {
        this.listVideos = worksheetItem[0].Items.filter((item) => item.WorksheetType === this.worksheetType.ProviderVideo);
        this.firstVideoItem = this.listVideos?.[0];
      }
    });
  }

  handleClickPlay(clickedVideo: WorksheetItem): void {
    this.firstVideoItem = clickedVideo;
  }
  hasWorksheetType(items: WorksheetItem[], worksheetType: number): boolean {
    const filteredItems = items.filter((item) => item.WorksheetType === worksheetType);
    if (filteredItems.length <= 0) {
      return false;
    } else {
      return true;
    }
  }
}
